import { HyperDropPanel } from './components/HyperDropPanel';
  document.addEventListener("DOMContentLoaded", function() {
    const panel = new HyperDropPanel({
      elements: {
        panel: document.querySelector('#main-menu-mobile'),
        backdrop: document.querySelector('.main-menu-mobile-backdrop'),
        closeBtn: document.querySelector('.main-menu-mobile-close'),
        toggle: document.querySelector('#main-menu-mobile-toggle'),
      }
    });

    const mobileMenuToggle = document.querySelector('#main-menu-mobile-toggle');
    const mobileMenuClose = document.querySelector('.main-menu-mobile-close');

    mobileMenuToggle.addEventListener('click', function() {
      this.classList.add('d-none');
      mobileMenuClose.classList.remove('d-none');
      document.body.classList.add('overflow-hidden');
      document.querySelector('html').classList.add('overflow-hidden');
    });

    mobileMenuClose.addEventListener('click', function() {
      this.classList.add('d-none');
      mobileMenuToggle.classList.remove('d-none');
      document.body.classList.remove('overflow-hidden');
      document.querySelector('html').classList.remove('overflow-hidden');
    });




  });
